<template>
  <div class="footer_menu">
    <span v-for="menu in menus" :key="menu.label">
      <FooterMenu
        :url="menu.url"
        :image="menu.image"
        :label="menu.label"
      />
    </span>
  </div>
</template>

<script>
import FooterMenu from '@/components/atoms/FooterMenu.vue';

export default {
  components: {
    FooterMenu,
  },

  data: () => ({
    menus: [
      {
        url: '/',
        image: '/img/menu/home.png',
        label: 'HOME',
      },
      {
        url: '/buy-point-history',
        image: '/img/menu/history.png',
        label: 'History',
      },
      {
        url: '/buy-point',
        image: '/img/menu/gems.png',
        label: 'Buy Gems',
      },
      {
        url: '/exchange-card',
        image: '/img/menu/coin.png',
        label: 'Coin',
      },
      {
        url: 'https://minny-online-store.iranoan.com/login',
        image: '/img/menu/contact.png',
        label: 'Contact',
      },
      {
        url: '/my-page',
        image: '/img/menu/mypage.png',
        label: 'My Page',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.footer_menu {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  z-index: 1;
  background-color: #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
}
</style>
